import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css'; // reuse same styles

function SmsConsent() {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-header">
        <Link to="/login" className="privacy-back-link">← Back</Link>
        <h1>📱 SMS Terms & Consent</h1>
        <p className="privacy-subtitle">How we use text messaging</p>
        <p className="privacy-effective">Effective Date: April 1, 2026 | Last Updated: April 7, 2026</p>
      </div>

      <div className="privacy-content">
        <section className="privacy-section privacy-highlight">
          <h2>SMS Opt-In Consent</h2>
          <p className="golden-rule">
            📱 By checking the SMS consent box during registration, you voluntarily agree to receive SMS messages from Belong.
          </p>
        </section>

        <section className="privacy-section">
          <h2>What Messages You Will Receive</h2>
          <p>Belong sends SMS messages for the following purposes only:</p>
          <ul>
            <li><span className="data-label">Phone Verification:</span> A one-time 6-digit code to verify your phone number during registration</li>
            <li><span className="data-label">Account Security:</span> Verification codes for login authentication</li>
          </ul>
          <p>We do not send marketing, promotional, or advertising messages via SMS.</p>
        </section>

        <section className="privacy-section">
          <h2>Message Frequency</h2>
          <ul>
            <li>Verification codes are sent only when you register or log in</li>
            <li>Typical frequency: 1-2 messages per login session</li>
            <li>You will never receive more than 5 SMS messages per day from Belong</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Message and Data Rates</h2>
          <p>
            Standard message and data rates may apply depending on your mobile carrier and plan. 
            Belong does not charge for SMS messages, but your carrier may.
          </p>
        </section>

        <section className="privacy-section">
          <h2>How to Opt Out</h2>
          <p>You can stop receiving SMS messages at any time by:</p>
          <ul>
            <li>Replying STOP to any message from Belong</li>
            <li>Deleting your account from the Profile page</li>
            <li>Contacting us at <a href="mailto:belong@ourbelong.com">belong@ourbelong.com</a></li>
          </ul>
          <p>
            After opting out, you will receive one final confirmation message. 
            You will no longer be able to use phone-based login without re-opting in.
          </p>
        </section>

        <section className="privacy-section">
          <h2>How to Get Help</h2>
          <p>
            For questions about SMS messaging, reply HELP to any message from Belong, 
            or contact us:
          </p>
          <ul>
            <li>Email: <a href="mailto:belong@ourbelong.com">belong@ourbelong.com</a></li>
            <li>In-app: <Link to="/help">Contact Us</Link></li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Your Privacy</h2>
          <p>
            Your phone number is encrypted and stored securely. We do not share your phone number 
            with third parties for marketing purposes. SMS delivery is handled by Twilio, our 
            messaging provider, solely for the purpose of delivering verification codes. 
            See our full <Link to="/privacy">Privacy Policy</Link> for details.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Supported Carriers</h2>
          <p>
            SMS messaging is supported on all major US carriers including AT&T, T-Mobile, Verizon, 
            Sprint, and most regional carriers. International carrier support may vary.
          </p>
        </section>

        <div className="privacy-footer">
          <p>💜 We only text you when it matters — to keep your account safe.</p>
        </div>
      </div>
    </div>
  );
}

export default SmsConsent;
